// extracted by mini-css-extract-plugin
export default {"container":"style_container__VECxd","mainHeading":"style_mainHeading__x86gC"};